import React, { ReactNode } from "react";
import { IListObj } from "../../../../types/genericTypes";
import DeviceContext from "../../../../service/indentifyDevice";
import { Idevice } from "../../../../types/device";
import NoDataContainer from "../../../../generic/noDataContainer";
import { SDevWiseStateComp } from "../obDeviceComp";
import { AObIPO, AObOFS, AObNCD, AObNFO } from "../../../../service/orderBook/obApiService";
import ObIpo from "../../instruments/primaryMarket/newOffers/obIpo";
import ObNcd from "../../instruments/primaryMarket/newOffers/obNcd";
import ObOfs from "../../instruments/primaryMarket/newOffers/obOfs";
import ObNfo from "../../instruments/primaryMarket/newOffers/obNfo";
import OnIpoMob from "../../instruments/primaryMarket/newOffers/obIpoMob";
import ObNcdMob from "../../instruments/primaryMarket/newOffers/obNcdMob";
import { PMErrorMessages } from "../../obConstants";
import { SLoader } from "../../../../generic/loader";
import { IOFSReq } from "../../../../types/components/orderBook/obTypes";
import moment from "moment";
import bStrg from "../../../../service/storageHelper";
import { subDays } from "../../../../service/dateTimeService";
import { config } from "../../../../../config/domain";
import ObNfoMob from "../../instruments/primaryMarket/newOffers/obNfoMob";

export interface IObNewOffersContProps {
	match?: any;
}

const ObNewOffersCont: React.FC<IObNewOffersContProps> = (props) => {
	const [hidepgNav, setHidePageNav] = React.useState<boolean>(false); //hide page navigation when enabled
	const [instrument, setInstrument] = React.useState<ReactNode>(<></>);

	// priNavOptions do not change (no need of state)
	const priNavOptions: Array<IListObj> = [
		{ value: "today", display: "Today's orders", href: "today" },
		{ value: "history", display: "History", href: "history" }
	];

	//url params controlled vars
	let history: boolean = props.match.params.pageNav === priNavOptions[1].value ? true : false;
	let instNav: string = props.match.params.inst.toLowerCase();
	//PmActiveInstNav hold the selected primary nav tab
	const PmActiveInstNav = React.useRef<string>(props.match.params.inst.toLowerCase());

	let todayDate: string = bStrg("todayDate") || new Date();

	function reducer(instWiseData: any) {
		return instWiseData;
	}
	function intialState() {
		return {
			ipo: [],
			ofs: [],
			ncd: [],
			nfo: []
		};
	}
	//reducer to preserve the data after mutliple renders
	const [instWiseData] = React.useReducer(reducer, intialState());

	//toggler to show and hide the page navigation in the events of any operation
	const hidePageNav = (toggle: boolean) => {
		setHidePageNav(toggle);
	};
	const setNHandle = (data: any) => {
		instWiseData[instNav] = data;
		handleSecNav(instNav);
	};

	const getIPOOrderbook = (res: any) => {
		if (PmActiveInstNav.current === "ipo") {
			res.data ? setNHandle(res.data.ordLst) : setNHandle([]);
		}
	};
	const getOFSOrderbook = (res: any) => {
		if (PmActiveInstNav.current === "ofs") {
			console.log(res);
		}
	};
	const getNCDOB = (res: any) => {
		if (PmActiveInstNav.current === "ncd") {
			(res.response ? res.response.data.ipoOrdBk : res.response) ? setNHandle(res.response.data.ipoOrdBk) : setNHandle([]);
		}
	};
	const getNFOOrders = (res: any) => {
		if (PmActiveInstNav.current === "nfo") {
			res.data ? setNHandle(res.data.ordLst) : setNHandle([]);
		}
	};

	const handleInstNav = (selectVal: string) => {
		instNav = selectVal.toLowerCase();
		setInstrument(SLoader(20, "blue"));

		switch (selectVal) {
			case "ipo":
				AObIPO(getIPOOrderbook);
				break;
			case "ofs":
				AObOFS(getOFSOrderbook, {
					exc: "NSE",
					fromDate: moment(new Date(todayDate)).format("DD/MM/YYYY"),
					toDate: moment(new Date(todayDate)).format("DD/MM/YYYY")
				} as IOFSReq);
				break;
			case "ncd":
				// getNCDOB(ncddata);
				AObNCD(getNCDOB);
				break;
			case "nfo":
				AObNFO(getNFOOrders, moment(subDays(new Date(todayDate), 15)).format("DD/MM/YYYY"), moment(new Date(todayDate)).format("DD/MM/YYYY"));

				break;
			default:
				console.log("not found");
				break;
		}
	};

	const handleDevice: Idevice = DeviceContext();

	//handles section navigation based on page navigation
	const handleSecNav = (nav: string) => {
		let inst: ReactNode = <></>,
			nodataNode: ReactNode = (
				<NoDataContainer
					txtHeading={!history && (nav === "ofs" || nav === "nfo") ? PMErrorMessages[nav] : ""}
					txtSubHeading={
						!history
							? nav === "ofs" || nav === "nfo"
								? "Investing today can help you grow your wealth"
								: PMErrorMessages[nav]
							: history
							? "There are no orders placed by you in this section"
							: ""
					}
					btnDet={
						!history && (nav === "ofs" || nav === "nfo")
							? {
									txt: "Place Order",
									clickHandler: () => {},
									type: "btn"
							  }
							: undefined
					}
					linkDet={
						history
							? {
									txt: "Go to Primary Markets page",
									href: config.rootUrl + "new-issues",
									type: "aLink"
							  }
							: undefined
					}
				/>
			);

		switch (nav) {
			case "ipo":
				inst =
					handleDevice.isDesktop || handleDevice.isTablet ? (
						<ObIpo data={instWiseData.ipo} isHistory={history} noDataNode={nodataNode} hidePageNav={hidePageNav} />
					) : (
						<OnIpoMob data={instWiseData.ipo} isHistory={history} noDataNode={nodataNode} hidePageNav={hidePageNav} />
					);
				break;
			case "ofs":
				inst = handleDevice.isDesktop || handleDevice.isTablet ? <ObOfs data={instWiseData.ofs} /> : <div></div>;

				break;
			case "ncd":
				inst =
					handleDevice.isDesktop || handleDevice.isTablet ? (
						<ObNcd data={instWiseData.ncd} isHistory={history} noDataNode={nodataNode} />
					) : (
						<ObNcdMob data={instWiseData.ncd} isHistory={history} noDataNode={nodataNode} />
					);

				break;
			case "nfo":
				inst =
					handleDevice.isDesktop || handleDevice.isTablet ? (
						<ObNfo data={instWiseData.nfo} isHistory={history} noDataNode={nodataNode} />
					) : (
						<ObNfoMob data={instWiseData.nfo} isHistory={history} noDataNode={nodataNode} />
					);

				break;
			default:
				console.log("not found");
				break;
		}
		setInstrument(<>{inst}</>);
	};

	//only on instrument change makes associated API call
	React.useEffect(() => {
		handleInstNav(instNav);
	}, [props.match.params.secNav]);

	React.useEffect(() => {
		handleSecNav(instNav);
	}, [props.match.params.pageNav]);

	return (
		<>
			{SDevWiseStateComp(
				priNavOptions,

				instrument,
				hidepgNav,
				handleDevice,
				handleInstNav
			)}
		</>
	);
};

export default ObNewOffersCont;
